// Labels PT-BR para valores tecnicos do banco (as operadoras nao falam ingles).
// O VALOR persistido continua em ingles (draft/live/...); so a EXIBICAO traduz.
// Pedido do Wladimir 2026-07-23: "as meninas ficam perguntando o que e draft".

export const PUBLICATION_STATUS_LABEL: Record<string, string> = {
  live: "Publicado",
  draft: "Rascunho",
  unpublished: "Despublicado",
  error: "Erro",
};

export const SISPLAN_STATUS_LABEL: Record<string, string> = {
  active: "Ativo",
  inactive: "Inativo",
};

export const JOB_ACTION_LABEL: Record<string, string> = {
  publish: "publicação",
  unpublish: "despublicação",
  republish: "republicação",
  sync_media: "sync de fotos",
  reseed_taxonomy: "reseed de categorias",
};

export const JOB_STATUS_LABEL: Record<string, string> = {
  queued: "na fila",
  running: "executando",
  done: "concluído",
  failed: "falhou",
};

export function pubStatusLabel(status: string): string {
  return PUBLICATION_STATUS_LABEL[status] ?? status;
}

export function sisplanStatusLabel(status: string | null | undefined): string {
  if (!status) return "—";
  return SISPLAN_STATUS_LABEL[status] ?? status;
}

export function jobLabel(action: string | undefined, status: string | undefined): string {
  const a = action ? (JOB_ACTION_LABEL[action] ?? action) : "";
  const s = status ? (JOB_STATUS_LABEL[status] ?? status) : "";
  return `${a} ${s}`.trim();
}
